import axios from "axios";
const op = require("../modulos/datos");

export const crearBitacora = async (tipoope, nomtab, idtab) => {
  try {
    const ip = localStorage.getItem("ip");
    const mac = localStorage.getItem("mac");
    const fechaSistema = localStorage.getItem("fechasistema");
    const idUsuario = localStorage.getItem("idusuario");
    const token = localStorage.getItem("jwtToken");
    const anioActual = new Date().getFullYear();
    const parseJSONSafe = (value) => {
      try {
        return value ? JSON.parse(value) : null;
      } catch (e) {
        console.warn("Error parsing JSON:", e);
        return value;
      }
    };
    const endpoint = `${op.conexion}/api/comun/crearbitacora`;
    const body = {
      tipope: tipoope,
      nomtabla: nomtab,
      idtab: idtab,
      nanio: parseInt(anioActual),
      nmesini: 1,
      nmesfin: 12,
      fecpag: null,
      numfac: null,
      monini: 0.0,
      monaju: 0.0,
      moncrea: 0,
      idusu: parseJSONSafe(idUsuario),
      fecope: fechaSistema,
      fecreal: fechaSistema,
      cdirip: parseJSONSafe(ip),
      cdirmac: parseJSONSafe(mac),
    };

    const response = await axios.post(endpoint, body, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.warn("Error en crearBitacora:", error);
    throw error; // Lanzar el error para manejarlo donde se llama
  }
};
